function Image({ src, width = 90, maxWidth = 50, alt = '', caption = '', centered = false }) {
    const img = (
        <img
            alt={alt}
            src={src}
            style={{ width: width + '%', maxWidth: maxWidth + 'em', display: 'block' }}
        />
    );

    if (caption) {
        return (
            <figure className={`imageFigure${centered ? ' imageCentered' : ''}`}>
                {img}
                <figcaption className="imageCaption">{caption}</figcaption>
            </figure>
        );
    }

    if (centered) {
        return <div style={{ display: 'flex', justifyContent: 'center' }}>{img}</div>;
    }

    return img;
}

function ImageInText({ src, align = 'left', alt = '', caption = '' }) {
    if (caption) {
        return (
            <figure className={`imageInTextFigure ${align === 'right' ? 'right' : 'left'}`}>
                <img alt={alt} src={src} />
                <figcaption className="imageCaption">{caption}</figcaption>
            </figure>
        );
    }

    return (
        <img
            alt={alt}
            src={src}
            className={`imageInText ${align === 'right' ? 'right' : 'left'}`}
            align={align}
        />
    );
}

function ImageLink({ src, width = 90, maxWidth = 50, alt = '', caption = '', centered = false, destination = '', newTab = true }) {
    return (
        <a href={destination} target={newTab ? '_blank' : '_self'} rel="noreferrer" className="imageLinkAnchor">
            <Image src={src} width={width} maxWidth={maxWidth} alt={alt} caption={caption} centered={centered} />
        </a>
    );
}

export { Image, ImageInText, ImageLink };
